// FILECONTENT_START src/common/modules/storage/index.ts
function removeStorageData(storage: Storage, key: string) {
  storage.removeItem(key);
}

function getStorageData<T = any>(
  storage: Storage,
  key: string
): Partial<T> | undefined {
  const json = storage.getItem(key);
  if (json) {
    return JSON.parse(json) as Partial<T>;
  }
}

function setStorageData<T = any>(
  storage: Storage,
  key: string,
  item?: Partial<T>
) {
  if (item) {
    storage.setItem(key, JSON.stringify(item));
  } else {
    storage.removeItem(key);
  }
}

export const SessionStorage = {
  set: <T = any>(key: string, item?: Partial<T>) =>
    setStorageData<T>(sessionStorage, key, item),
  get: <T = any>(key: string) => getStorageData<T>(sessionStorage, key),
  remove: (key: string) => removeStorageData(sessionStorage, key),
};

// FILECONTENT_END src/common/modules/storage/index.ts